export default __webpack_public_path__ + "static/media/profile_placeholder.a6889a67.png";